import { SimplifiedUserRole } from '@platform/client/schemas';
import { createContext } from 'react';

export const DirectoryPageContext = createContext<{
  targetUserId: number;
  sendingFromRole: SimplifiedUserRole;
  // The query key of the API function the refetch after sending an intro
  queryKey: readonly string[];
}>({
  targetUserId: -1,
  sendingFromRole: 'ADMIN', // Just a default value; will be overwritten
  queryKey: [],
});
